import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=1b13f8d8&scoped=true"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"
import style0 from "./Members.vue?vue&type=style&index=0&id=1b13f8d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13f8d8",
  null
  
)

export default component.exports